import { chakra } from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../components/modal-wrapper';

export const NewCoursesPromoVideoWrapper = chakra(ModalWrapper, {
    label: 'new-courses-promo-video-wrapper',
    baseStyle: {
        flexDirection: 'column',
        padding: 0,
        overflow: 'hidden'
    }
});
